import { useLazyQuery, useQuery } from "@apollo/client";
import { GIVEN_CANS_LIST } from "../given-cans.queries";
import {
  GivenCansListQuery,
  GivenCansListQueryVariables,
} from "../../../__generated__/GivenCansListQuery";

export const useGivenCansList = (variables: GivenCansListQueryVariables) => {
  return useQuery<GivenCansListQuery, GivenCansListQueryVariables>(GIVEN_CANS_LIST, {
    variables,
  });
};

export const useLazyGivenCansList = () => {
  return useLazyQuery<GivenCansListQuery, GivenCansListQueryVariables>(GIVEN_CANS_LIST);
};
